import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { AiRecoveryOptions } from "../ea.enums";

const base = "ai";
const ai = createEndpointBase(base);

export const aiEndpoints = {
  aiCheckConnection: ai({
    method: "POST",
    path: "check-connection",
    request: z.any(),
    response: z.any(),
    requestType: {} as {
      aiProvider: "openai" | "anthropic" | "google" | "azure" | "openrouter";
      model: string;
      baseUrl: string;
      apiKey: string;
    },
    responseType: {} as { success: boolean; error?: string },
    description: "Checks connection to an AI provider.",
  }),
  aiGenerateText: ai({
    method: "POST",
    path: "generate-text",
    request: z.any(),
    response: z.any(),
    requestType: {} as any,
    responseType: {} as any,
    description: "Generates text using the configured AI model and tools.",
  }),
  aiGenerateObject: ai({
    method: "POST",
    path: "generate-object",
    request: z.any(),
    response: z.any(),
    requestType: {} as any,
    responseType: {} as any,
    description: "Generates a structured object using the configured AI model and schema.",
  }),
  aiGetSettings: ai({
    method: "GET",
    path: "settings",
    request: z.any(),
    response: z.any(),
    responseType: {} as {
      chatEnabled: boolean;
      voiceChatEnabled: boolean;
      aiRecovery: AiRecoveryOptions;
      model: string;
      aiProvider: string;
      tokenLimits: number;
    },
    description: "Retrieves current AI model settings.",
  }),
} as const;
